import {
    getSessionStorageValue,
    isValidString,
    LOCAL_STORAGE_KEYS,
    setSessionStorageValue,
} from '../common/CommonUtilsMethods';
import type { PendingMfaChallengeState } from './WorkyPendingMfaChallengeInterfaces';
import { CognitoMfaChallengeStep } from './WorkyPendingMfaChallengeInterfaces';

const isSupportedMfaChallengeStep = (challengeStep: string): challengeStep is CognitoMfaChallengeStep => {
    return (
        challengeStep === CognitoMfaChallengeStep.CONFIRM_SIGN_IN_WITH_SMS_CODE ||
        challengeStep === CognitoMfaChallengeStep.CONFIRM_SIGN_IN_WITH_TOTP_CODE ||
        challengeStep === CognitoMfaChallengeStep.CONTINUE_SIGN_IN_WITH_MFA_SELECTION
    );
};

const storePendingMfaChallengeState = (pendingMfaChallengeState: PendingMfaChallengeState): void => {
    setSessionStorageValue({
        key: LOCAL_STORAGE_KEYS.PENDING_MFA_EMAIL,
        value: pendingMfaChallengeState.emailAddress,
    });
    setSessionStorageValue({
        key: LOCAL_STORAGE_KEYS.PENDING_MFA_CHALLENGE_STEP,
        value: pendingMfaChallengeState.mfaChallengeStep,
    });
    if (isValidString(pendingMfaChallengeState.primaryWorkyCorpId)) {
        setSessionStorageValue({
            key: LOCAL_STORAGE_KEYS.PENDING_MFA_PRIMARY_WORKY_CORP_ID,
            value: pendingMfaChallengeState.primaryWorkyCorpId,
        });
        return;
    }
    sessionStorage.removeItem(LOCAL_STORAGE_KEYS.PENDING_MFA_PRIMARY_WORKY_CORP_ID);
};

const readPendingMfaChallengeState = (): PendingMfaChallengeState | null => {
    const emailAddress: string = getSessionStorageValue({ key: LOCAL_STORAGE_KEYS.PENDING_MFA_EMAIL });
    const mfaChallengeStep: string = getSessionStorageValue({
        key: LOCAL_STORAGE_KEYS.PENDING_MFA_CHALLENGE_STEP,
    });

    if (!isValidString(emailAddress) || !isSupportedMfaChallengeStep(mfaChallengeStep)) {
        return null;
    }

    const primaryWorkyCorpIdFromSession: string = getSessionStorageValue({
        key: LOCAL_STORAGE_KEYS.PENDING_MFA_PRIMARY_WORKY_CORP_ID,
    });
    const primaryWorkyCorpId: string | null = isValidString(primaryWorkyCorpIdFromSession)
        ? primaryWorkyCorpIdFromSession.trim()
        : null;

    return {
        emailAddress: emailAddress.trim().toLowerCase(),
        mfaChallengeStep,
        primaryWorkyCorpId,
    };
};

const clearPendingMfaChallengeState = (): void => {
    sessionStorage.removeItem(LOCAL_STORAGE_KEYS.PENDING_MFA_EMAIL);
    sessionStorage.removeItem(LOCAL_STORAGE_KEYS.PENDING_MFA_CHALLENGE_STEP);
    sessionStorage.removeItem(LOCAL_STORAGE_KEYS.PENDING_MFA_PRIMARY_WORKY_CORP_ID);
};

export {
    clearPendingMfaChallengeState,
    readPendingMfaChallengeState,
    storePendingMfaChallengeState,
};
